import { render, staticRenderFns } from "./AppointmentEvents.vue?vue&type=template&id=4ed98360&scoped=true&"
import script from "./AppointmentEvents.vue?vue&type=script&lang=js&"
export * from "./AppointmentEvents.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentEvents.vue?vue&type=style&index=0&id=4ed98360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed98360",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VDivider,VFlex,VIcon,VLayout})
